import React, { useState } from "react";
import HeroImg from "../../Shared components/HeroImg";
import { useNavigate } from "react-router-dom";
import { MdArrowBackIosNew } from "react-icons/md";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import { Config } from "../../API/config";
import BeatLoader from "react-spinners/esm/BeatLoader";


const ResetPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [Loading, setLoading] = React.useState<boolean>(false)

    const validateEmail = (email: string) => {
        return /\S+@\S+\.\S+/.test(email);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        try {
            setLoading(true)
            e.preventDefault();

            if (!email.trim()) {
                toast.error("يرجى إدخال البريد الإلكتروني");
                return;
            }

            if (!validateEmail(email)) {
                toast.error("يرجى إدخال بريد إلكتروني صحيح");
                return;
            }

            let data = await axios.post(
                Config.requestReset,
                { email },
                {
                    withCredentials: true,
                }

            );
            if (data.data.statusCode == 201) {

                navigate(`/otp/${email}`);
            }
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error("خطأ غير متوقع، حاول لاحقًا");
            }


        }
        finally {
            setLoading(false);
        }


    };

    return (
        <>
            <Toaster />
            <div className="flex flex-row min-h-screen w-full">
                <HeroImg />
                <div className="flex flex-col items-end justify-start w-full mt-10 px-24 relative">
                    <button onClick={() => navigate(-1)}>
                        <div className='w-[40px] h-[40px] border absolute top-0 left-0 cursor-pointer ml-6 border-neutral-800 rounded-full flex justify-center items-center hover:bg-primary-100 transition-all duration-150 group'>
                            <MdArrowBackIosNew
                                size={22}
                                color='#4a4a4a'
                                fontWeight={200}
                                className="text-neutral-900 group-hover:translate-x-[-2px] group-hover:fill-white transition-transform duration-150"
                            />
                        </div>
                    </button>
                    <div className='w-full'>
                        <div className="w-full flex justify-end">
                            <h2 className="text-[32px] leading-[67.58px] font-[500] text-neutral-900">
                                Otlob Coach مرحباً بكم في
                            </h2>
                        </div>
                        <div className="w-full flex justify-end">
                            <p className="text-[16px] leading-[24px] font-[400] text-neutral-900">
                                اعادة تعيين كلمة السر
                            </p>
                        </div>
                        <div className='w-full my-3 '>
                            <form onSubmit={handleSubmit}>
                                <div className='w-full my-5'>
                                    <label htmlFor="resetPassemail" className="block mb-2 text-sm font-medium text-neutral-600 text-right">
                                        البريد الإلكتروني
                                    </label>
                                    <input
                                        type="email"
                                        id="resetPassemail"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        className="text-right border border-gray-300 text-black text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-4"
                                        required
                                    />
                                </div>

                                <div className='w-full my-5 flex justify-center'>
                                    {Loading ?
                                        <BeatLoader className="mt-5" color="#072605" />
                                        :

                                        <button
                                            type="submit"
                                            className="bg-white text-primary-500 p-3 w-full mt-5 border rounded-md border-primary-500 md:w-[258px] hover:bg-primary-500 hover:text-white hover:border-transparent transition-all duration-500"
                                        >
                                            طلب اعادة تعيين كلمة السر
                                        </button>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ResetPassword;
